/// <amd-module name="SuiteCommerce.SizeChart.PDP.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.SizeChart.PDP.View", ["require", "exports", "Backbone", "SuiteCommerce.SizeChart.PDP.Item.Model", "suite_commerce_size_chart_pdp.tpl", "SuiteCommerce.SizeChart.PDP.Configuration", "SuiteCommerce.SizeChart.Instrumentation"], function (require, exports, Backbone_1, PDP_Item_Model_1, PDPTemplate, PDP_Configuration_1, Instrumentation_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var PDPView = /** @class */ (function (_super) {
        __extends(PDPView, _super);
        function PDPView(options) {
            var _this = _super.call(this, options) || this;
            _this.template = PDPTemplate;
            _this.events = {
                'click [data-action="openSizeChart"]': 'openSizeChartAction'
            };
            _this.pdp = options.pdp;
            _this.router = options.router;
            _this.model = new PDP_Item_Model_1.PDPItemModel(_this.getItemInfo());
            _this.setupListeners();
            _this.logSizeChartUsage();
            return _this;
        }
        PDPView.prototype.setupListeners = function () {
            var _this = this;
            this.pdp.on('afterOptionSelection', function () {
                var lastSizeChartId = _this.model.sizeChartId;
                _this.model.set(_this.getItemInfo());
                if (lastSizeChartId !== _this.model.sizeChartId) {
                    _this.render();
                    _this.logSizeChartUsage();
                }
            });
        };
        PDPView.prototype.getItemInfo = function () {
            var selectedMatrixChild = this.pdp.getSelectedMatrixChilds() &&
                this.pdp.getSelectedMatrixChilds().length === 1
                ? this.pdp.getSelectedMatrixChilds()[0]
                : null;
            if (selectedMatrixChild && selectedMatrixChild[PDP_Item_Model_1.ItemFields.sizeChartId]) {
                return selectedMatrixChild;
            }
            return this.pdp.getItemInfo().item;
        };
        PDPView.prototype.logSizeChartUsage = function () {
            if (this.model.sizeChartId) {
                var sizeChartUsageLog = Instrumentation_1.default.getLog('sizeChartUsageLog');
                sizeChartUsageLog.setParameters({
                    activity: 'Size Chart Usage',
                    message: "Size Chart: Id: " + this.model.sizeChartId + " - Name: " + this.model.sizeChartName,
                });
                sizeChartUsageLog.submit();
            }
        };
        PDPView.prototype.openSizeChartAction = function (event) {
            event.preventDefault();
            if (!this.router.isSearchingSizeCharts) {
                this.router.showSizeChartView(this.model.sizeChartId, true);
            }
            this.logClickInSizeChartLink();
            return false;
        };
        PDPView.prototype.logClickInSizeChartLink = function () {
            var clickInSizeChartLinkLog = Instrumentation_1.default.getLog('clickInSizeChartLinkLog');
            clickInSizeChartLinkLog.setParameters({
                activity: 'Click in Size Char Link',
                message: "Size Chart: Id: " + this.model.sizeChartId + " - Name: " + this.model.sizeChartName,
            });
            clickInSizeChartLinkLog.submit();
        };
        PDPView.prototype.getContext = function () {
            return {
                sizeChartId: this.model.sizeChartId,
                sizeChartName: this.model.sizeChartName,
                hyperlinkText: PDP_Configuration_1.PDPConfiguration.hyperlinkText,
                sizeChartPageURL: PDP_Configuration_1.PDPConfiguration.sizeChartPageURL,
                isAssociatedToSizeChart: this.model.hasSizeChart(),
                sizeChartUrlComponent: this.model.sizeChartURLComponent,
            };
        };
        return PDPView;
    }(Backbone_1.View));
    exports.PDPView = PDPView;
});
